const AuthorizationStatus = {
  AUTH: "AUTH",
  NO_AUTH: "NO_AUTH",
};

export const { AUTH, NO_AUTH } = AuthorizationStatus;
